"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class SearchCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackSearchEvent(this.input);
    }
}
exports.SearchCommand = SearchCommand;
